import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Trainee } from 'app/shared/models/class/trainee/trainee';
import { AuthService } from 'app/shared/services/auth/auth.service';
import { DataService } from 'app/shared/services/data/data.service';
import { FaiconService } from 'app/shared/services/faicon/faicon.service';
import { TraineeService } from 'app/shared/services/trainee/trainee.service';
import { OpendialogAddEditTraineeComponent } from '../dialog/open-dialog-add-edit-trainee/opendialog-add-edit-trainee.component';

@Component({
  selector: 'app-my-trainees',
  templateUrl: './my-trainees.component.html',
  styleUrls: ['./my-trainees.component.scss']
})
export class MyTraineesComponent implements OnInit {

  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;

  displayedColumns: string[] = ['lastname', 'firstname', 'emergencyPhoneNumber', 'overview'];
  dataSource: MatTableDataSource<Trainee>;
  userKey: number;
  trainees: Trainee[];
  traineeOverView: Trainee;

  length: number;
  pageSize = 5;
  pageSizeOptions: number[] = [5, 10, 25, 50];
  pageEvent: PageEvent;

  color: ThemePalette = 'primary';

  traineeMobilForm: UntypedFormGroup;
  searchForm: UntypedFormGroup;
  valueInput: string;
  traineeFiltered: Trainee[] = [];

  constructor(
    private traineeService: TraineeService,
    private authService: AuthService,
    private dataService: DataService,
    private formBuilder: UntypedFormBuilder,
    private dialog: MatDialog,
    private faIconService: FaiconService,
  ) {
  }

  ngOnInit(): void {
    this.initComponent();
    this.initForm();
  }

  getFaIcon(faIcon: string): string {
    return this.faIconService.getFaIcon(faIcon);
  }

  changePreview(trainee: Trainee): void {
    this.traineeOverView = trainee;
  }

  applyFilter(filterValue: string) {
    this.valueInput = filterValue;
    const keyWord = filterValue.trim().toLowerCase();
    this.dataSource.filter = keyWord;
    this.traineeFiltered = this.trainees.filter(trainee => {
      if (JSON.stringify(trainee).toLowerCase().includes(keyWord)) {
        return trainee;
      }
    });

    if (this.traineeFiltered.length) {
      this.f.trainee.setValue(this.traineeFiltered[0]);
      this.changePreview(this.traineeFiltered[0]);
    } else {
      this.f.trainee.setValue('no_value');
    }
  }

  resetSearch(): void {
    this.valueInput = '';
    this.traineeFiltered = [];
    this.fsearch.keyword.reset();
    this.f.trainee.reset();
    this.seTable(this.trainees);
    this.f.trainee.setValue(this.trainees[0]);
    this.changePreview(this.trainees[0]);
  }



  openDialogAddOrEditTrainee(action: string, trainee?: Trainee) {
    const dialogRef = this.dialog.open(OpendialogAddEditTraineeComponent, {
      data: { action, trainee },
      minWidth: '50%',
      height: '80%'
    });

    dialogRef.afterClosed().subscribe({
      next: (res) => {
        if (res) {
        this.getTrainees();
        }

        // this.resetSearch();
      }
    });
  }

  updateTrainee(isUpdate: boolean): void {
    if (isUpdate) {
      this.getTrainees();
      // this.resetSearch();
    }
  }

  private seTable(trainees: Trainee[]): void {
    this.dataSource = new MatTableDataSource<Trainee>(trainees);
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
    this.length = trainees.length;
  }


  private getTrainees(): void {
    this.traineeService.getTrainees(this.userKey).subscribe({
      next: trainees => {
        if (!this.trainees) {
          this.f.trainee.setValue(trainees[0]);
          this.traineeOverView = trainees[0];
        }
        this.trainees = trainees;
        this.seTable(trainees);
      }
    });
  }

  private initComponent(): void {
    this.dataService.titleHomePage.next('Mes stagiaires');
    this.userKey = +this.authService.getDecodedToken().sub;
    this.getTrainees();
  }

  get f() {
    return this.traineeMobilForm.controls;
  }
  get fsearch() {
    return this.searchForm.controls;
  }

  private initForm(): void {
    this.traineeMobilForm = this.formBuilder.group({
      trainee: ['']
    });

    this.traineeMobilForm.get('trainee').valueChanges.subscribe((trainee) => {
      if (trainee) {
        this.traineeOverView = trainee;
      }
    })

    this.searchForm = this.formBuilder.group({
      keyword: ['']
    });
  }

}
